import React from 'react';
import { css } from 'aphrodite';
import styles from './live-location-marker-styles';
import './live-location-marker-styles.css';

const LiveLocationMarkerView = (props) => (
  <div className={css(styles.root)} onMouseEnter={props.mouseEnter} onMouseLeave={props.mouseLeave}>

    <div className={css(styles.driverContainer, props.expanded && styles.driverContainerExpanded)}>
      <div className={css(styles.driver)}>
        <div>{props.driver.firstName + ' ' + props.driver.lastName}</div>
      </div>
    </div>

    {!props.expanded && <div className="ring-container" onClick={() => props.setCurrentDriverCardOnMap(props.driver, props.lat, props.lng)} style={{cursor: props.hovered? 'pointer': 'default'}}>
      <div className="ringring"/>
      <div className="circle"/>
    </div>}

  </div>
);

export default LiveLocationMarkerView;



// WEBPACK FOOTER //
// ./src/components/map-markers/live-location-marker-view.js